import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';
import { IRegEdIntegrationStatus } from './types';

export const REGED_INTEGRATION_QUERY_KEY = 'regEdIntegration';

/**
 * The API returns a synthesized empty record (not a 404) when no integration exists, so
 * `configurationStatus.needsConfiguration` drives the connect flow. Note configured ≠ enabled.
 */
export const useRegEdIntegrationQuery = ({
	enabled = true,
	impersonationContext,
}: {
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
} = {}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryKey: [REGED_INTEGRATION_QUERY_KEY, impersonationContext?.account?.id],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<IRegEdIntegrationStatus>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'compliance/regEd/integration',
				}),
				'GET'
			),
		meta: {
			toastErrorMessage: 'Failed to load the RegEd integration.',
		},
	});
};

export const invalidateRegEdIntegration = () => {
	reactQueryClient.invalidateQueries({ queryKey: [REGED_INTEGRATION_QUERY_KEY] });
};
